import React, { PureComponent } from "react"
import { connect } from "react-redux"
import { withStyles } from "@mui/styles"
import FormControl from "@mui/material/FormControl"
import Button from "@mui/material/Button"
import { Field, reduxForm, formValueSelector, getFormMeta } from "redux-form"
import ReduxTextField from "../../components/form/ReduxTextField"
import { userValidator } from "../../utils/validators"
import { COLORS } from "../../utils"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import LoginChecklist from "../login/LoginChecklist"

const styles = {
    container: {
        backgroundColor: COLORS.WHITE,
        opacity: 1,
        outline: "none",
        overflow: "auto",
        zIndex: 1300,
        height: "100%"
    },
    titleContainer: {
        textAlign: "center",
        margin: 16
    },
    fieldsContainer: {
        width: "100%"
    },
    formControl: {
        width: 280,
        margin: 16
    },
    buttonContainer: {
        width: "100%"
    },
    submitButton: {
        float: "right",
        margin: 16
    }
}

export class UserForm extends PureComponent {
    render() {
        const { classes, handleSubmit, createUser, onClose, passwordValue, passwordTouched } = this.props

        return (
            <div className={classes.container}>
                <h2 className={classes.titleContainer}>
                    Créer un nouvel utilisateur
                    <IconButton aria-label="Fermer" onClick={onClose} size="large">
                        <CloseIcon/>
                    </IconButton>
                </h2>

                <form onSubmit={handleSubmit(createUser)}>
                    <div className={classes.fieldsContainer}>
                        <div>
                            <FormControl margin="normal" className={classes.formControl} required>
                                <Field name="email" label="Email" component={ReduxTextField} />
                            </FormControl>
                        </div>
                        <div>
                            <FormControl margin="normal" className={classes.formControl}>
                                <Field name="password" label="Mot de passe" component={ReduxTextField} type="password" />
                            </FormControl>
                            <div style={{ marginLeft: 16, width: 280 }}>
                                <LoginChecklist password={passwordValue || ""} touched={passwordTouched} />
                            </div>
                        </div>
                    </div>
                    <div className={classes.buttonContainer}>
                        <Button
                            className={classes.submitButton}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            Enregistrer
                        </Button>
                    </div>
                </form>
            </div>
        )
    }
}

UserForm = reduxForm({
    form: "user",
    enableReinitialize: false,
    validate: userValidator
})(UserForm)

const selector = formValueSelector("user")
const metaSelector = getFormMeta("user")

const styledUserForm = withStyles(styles)(
    connect(state => ({
        passwordValue: selector(state, "password"),
        passwordTouched: metaSelector(state)?.password?.touched || false
    }))(UserForm)
)

export default styledUserForm